import React, { Component } from "react";

//Import CSS
import "./tracking.css";

//Import internal components
import AppContext from "../appContext";
import Back from "../main/back";
import TrackingLabChoose from "./tracking-inputs/tracking-labchoose";
import TrackingInputDate from "./tracking-inputs/tracking-input-date";
import TrackingInputCNPJ from "./tracking-inputs/tracking-input-cnpj";
import TrackingSearchButton from "./tracking-inputs/tracking-search-button";
import TrackingTableHead from "./tracking-table/tracking-table-head";
import Input from "../components/inputs/input";
import FilterSelect from "../components/Filtro/ColapseFilter/Select/filter-select";
import BaseColapse from "../components/Filtro/ColapseFilter/baseColapse";
import FilterInput from "../components/Filtro/ColapseFilter/Input/filter-input";
import { getCampanha } from "../Functions/campanha/get-campanha";
import ResumoLateral from "../components/resumo-lateral";
import { Container } from "@material-ui/core";
import CnpjUtils from "../shared/utils/CnpjUtils";
//Import external components
import { Redirect } from "react-router-dom";
import Moment from "moment";
import Swal from "sweetalert2";
import { redirectPage } from "../components/utils/redirectpage";
import { getRedes } from "../Functions/redes/getRedes";
import { startFlowTrace, stopFlowTrace } from "../shared/utils/flow-trace";

//Import images

const CAMPANHA_SEM_PROMOCAO = "SEM_PROMOCAO";
const OPCAO_SEM_PROMOCAO = { label: "Sem promoção", value: CAMPANHA_SEM_PROMOCAO };

class Tracking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      laboratorio_nome: "",
      laboratorio_cnpj: "",
      pedido_laboratorio: "",
      pedido_otica: "",
      cnpj_number: "",
      //seta data inicio que mostra no input date para 30 dias atrás
      dia_inicio: new Date().setDate(new Date().getDate() - 60),
      //seta data fim que mostra no input date para hoje
      dia_fim: new Date(),
      //seta data inicio da integração para 60 dias atrás no formato correto
      data_inicio: Moment(new Date().setDate(new Date().getDate() - 60)).format("YYYY-MM-DD"),
      //seta data fim da integração para hoje no formato correto
      data_fim: Moment(new Date()).format("YYYY-MM-DD"),
      resposta_tabela: false,
      loading: false,
      classOpacity: "Nopacity",
      redirectL: false,
      result100: false,
      result404: false,
      result504: false,
      campoCnpjLiberado: false,
      redes: [],
      redeOticaAux: true,
      detailOrder: false,
      open: "",
      arrow: "",
      lab: null,
      novosFiltrosTracking: false,
      tipoCampanhaFlag: false,
      tipo_pedido: "",
      pedido_status: "",
      pedido_origem: "",
      pedido_id_par: "",
      pedido_nota_fiscal: "",
      serie_nota_fiscal: "",
      pedido_campanha: "",
      pedido_cupom: "",
      pedido_tipo_campanha: "",
      lista_campanhas_tipos: [],
      lista_campanhas: [],
      pedido_tipo_campanha_lista: [],
      pedido_campanha_lista: [],
    };

    if (sessionStorage.getItem("token") !== null) {
      Tracking.contextType = AppContext;
      this.setLabData = this.setLabData.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.handleChangeFilter = this.handleChangeFilter.bind(this);
      this.handleChange_data_inicio = this.handleChange_data_inicio.bind(this);
      this.handleChange_data_fim = this.handleChange_data_fim.bind(this);
      this.changeState = this.changeState.bind(this);
      this.integraPedido = this.integraPedido.bind(this);
      this.openSummary = this.openSummary.bind(this);

      const role = Tracking.contextType._currentValue.userSession.modulos.find(element => element === "Tracking");
      if (!role) {
        this.state = { redirect: true };
      }
    } else {
      this.state = { redirectL: true };
    }
  }

  async componentDidMount() {
    startFlowTrace("tracking");
    redirectPage(this.context.userSession, "/tracking");
    if (sessionStorage.getItem("token")) {
      if (this.context.userSession.redeOticas) {
        this.setState({ redeOticaAux: false });
      }

      // integração no OEC para ver todos os papéis que tem marcação de multiplas óticas
      const papeis = [];
      const requestOptions = {
        method: "GET",
      };

      fetch(process.env.REACT_APP_LABS_API + "get_multioptics_roles.php", requestOptions)
        .then(response => {
          return response.json();
        })
        .then(json => {
          if (json.status === "sucesso") {
            if (json.items) {
              for (var i = 0; i < json.items.length; i++) {
                var papel = {
                  nome: json.items[i].recordName,
                };
                papeis.push(papel);
              }
            }
            this.setState({ listaPapeis: papeis });

            var user_role = this.context.userSession.papel;
            var roles = JSON.stringify(this.state.listaPapeis);

            // compara os papéis de multiplas oticas do OEC com o papel do usuário logado, se ele estiver na lista, o campo CNPJ aparece na tela
            if (roles && roles.match(user_role)) {
              this.setState({
                input_cnpj: true,
              });
            }
          }
        });
    } else {
      this.setState({ redirectL: true });
    }

    try {
      const tipos = await getCampanha();
      if (tipos?.items) {
        this.setState({
          lista_campanhas_tipos: tipos,
          pedido_tipo_campanha_lista: tipos.items.tipoCampanha || [],
          pedido_campanha_lista: tipos.items.campanha || [],
        });
      }
    } catch (error) {
      console.error("Erro ao carregar campanhas:", error);
    }
  }

  componentWillUnmount() {
    stopFlowTrace("tracking");
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.autoSearch && !prevState.autoSearch) {
      this.setState({ autoSearch: false });
      this.changeState();
    }
  }

  borderColor(idElement, color = "#f70017") {
    if (!idElement) return;

    if (Array.isArray(idElement)) {
      idElement.forEach(el => this.borderColor(el, color));
      return;
    }

    const element = document.getElementById(idElement) || document.querySelector(`[name="${idElement}"]`);

    if (element) {
      element.style.boxShadow = `0 0 0 1px ${color}`;
      element.style.border = color;
      element.style.outline = "none";
    }
  }

  setLabData(e, label, detailOrder, params, novosFiltrosTracking, tipoCampanhaFlag) {
    if (e.value) {
      const isRedeOticas = this.context.userSession.redeOticas;
      const isLaboratorio = this.context.userSession.papelCategoria === "LABORATORIO";
      const shouldAutoSearch = !isRedeOticas && !isLaboratorio && !this.state.input_cnpj;

      let cnpjState = { campoCnpjLiberado: true };
      if (isLaboratorio) {
        if (e.value === this.context.userSession.conta) {
          cnpjState = { campoCnpjLiberado: true, cnpj_number: this.state.cnpj_number_aux };
        } else {
          cnpjState = { campoCnpjLiberado: false, cnpj_number_aux: this.state.cnpj_number, cnpj_number: "" };
        }
      }

      if (isRedeOticas) {
        this.listarRedesOticas(e.value);
      }

      this.setState({
        ...cnpjState,
        redeOticaAux: isRedeOticas ? false : this.state.redeOticaAux,
        lab: params,
        laboratorio_nome: label,
        laboratorio_cnpj: e.value,
        detailOrder: detailOrder,
        novosFiltrosTracking: novosFiltrosTracking === true,
        tipoCampanhaFlag: tipoCampanhaFlag === true,
        autoSearch: shouldAutoSearch,
        ...(shouldAutoSearch ? {
          dia_inicio: new Date().setDate(new Date().getDate() - 60),
          dia_fim: new Date(),
          data_inicio: Moment(new Date().setDate(new Date().getDate() - 60)).format("YYYY-MM-DD"),
          data_fim: Moment(new Date()).format("YYYY-MM-DD"),
        } : {}),
      });
      this.borderColor("lab", "#B5B5B5");
    } else {
      this.setState({
        laboratorio_nome: "",
        laboratorio_cnpj: "",
        detailOrder: false,
        lab: null,
        novosFiltrosTracking: false,
        tipoCampanhaFlag: false,
        autoSearch: false,
      });
    }
  }

  obterOtica(laboratorio) {
    const requestOptions1 = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ cnpj: this.context.userSession.conta }),
    };

    fetch(process.env.REACT_APP_LABS_API + "get_account_data.php", requestOptions1)
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (this.context.userSession.redeOticas) {
          this.setState({ oticaPrincipal: json.nome, cnpjPrincipal: json.cnpj }, this.listarRedesOticas(laboratorio));
        } else {
          const redes = [];
          var rede = {
            label: json.nome,
            value: json.cnpj,
          };
          redes.push(rede);
          this.setState({ redes: redes, cnpjPrincipal: json.cnpj });
        }
      });
  }

  handleChange(e) {
    let state = {};
    const name = e.target.getAttribute("name");
    const { value } = e.target;

    //valida o formato do numero do pedido laboratorio
    //pedido otica pode ser qualquer coisa, então não tem validação
    if (e.target.getAttribute("name") === "pedido_laboratorio") {
      if (!Number(value) && value !== "") {
        return;
      }
    }
    //seta o numero do pedido no state
    state[name] = value ? value : "";
    this.setState(state);
    this.borderColor(name, "#B5B5B5");
  }

  handleChangeFilter(name, type) {
    const { lista_campanhas_tipos } = this.state;

    const dependencies = {
      pedido_nota_fiscal: "serie_nota_fiscal",
      serie_nota_fiscal: "pedido_nota_fiscal",
    };

    const dependente = dependencies[name];

    if (dependente) {
      const campoValue = this.state[name];
      const dependenteValue = this.state[dependente];

      const setBorder = (campo, isError) => {
        const element = document.getElementById(campo);
        if (!element) return;
        if (isError) {
          this.borderColor(campo);
        } else {
          this.borderColor(campo, "#B5B5B5");
        }
      };

      if (campoValue && !dependenteValue) {
        setBorder(dependente, true);
      } else {
        setBorder(dependente, false);
      }

      if (dependenteValue && !campoValue) {
        setBorder(name, true);
      } else {
        setBorder(name, false);
      }
    }

    const { tipoCampanha = [], lista = [] } = lista_campanhas_tipos?.items || {};

    const currentValue = (this.state[name] || "").trim();

    if (name === "pedido_campanha") {
      const relacao = lista.find(item => item.Campanha_c.toUpperCase() === currentValue.toUpperCase());

      const tiposRelacionados = relacao ? tipoCampanha.filter(tc => relacao.TipoCampanha_c.toUpperCase().includes(tc.label.toUpperCase())) : [];

      this.setState({
        pedido_campanha: currentValue,
        pedido_tipo_campanha_lista: tiposRelacionados,
      });
    }
  }

  handleChange_data_inicio = date => {
    //trata o formato da data
    const diaInicio = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_inicio: diaInicio,
      //seta data para exibir no input date
      dia_inicio: date,
    });
  };

  handleChange_data_fim = date => {
    //trata o formato da data
    const diaFim = date ? Moment(date).format("YYYY-MM-DD") : "";
    this.setState({
      //seta data para integração
      data_fim: diaFim,
      //seta data para exibir no input date
      dia_fim: date,
    });
  };

  cleanFilters() {
    this.setState({
      tipo_pedido: "",
      pedido_status: "",
      pedido_origem: "",
      pedido_id_par: "",
      pedido_nota_fiscal: "",
      serie_nota_fiscal: "",
      pedido_campanha: "",
      pedido_cupom: "",
      pedido_tipo_campanha: "",
      pedido_campanha_lista: this.state.lista_campanhas_tipos?.items?.campanha || [],
      pedido_tipo_campanha_lista: this.state.lista_campanhas_tipos?.items?.tipoCampanha || [],
    });
    this.borderColor("pedido_tipo_campanha", "#B5B5B5");
    this.borderColor("pedido_campanha", "#B5B5B5");
    this.borderColor("serie_nota_fiscal", "#B5B5B5");
    this.borderColor("pedido_nota_fiscal", "#B5B5B5");
  }

  async changeState() {
    const dependencies = {
      pedido_nota_fiscal: "serie_nota_fiscal",
      serie_nota_fiscal: "pedido_nota_fiscal",
    };

    const fieldLabels = {
      pedido_nota_fiscal: "Nota Fiscal",
      serie_nota_fiscal: "Série da Nota Fiscal",
    };

    const camposComErro = new Set();

    for (const [campo, dependente] of Object.entries(dependencies)) {
      const valorCampo = this.state[campo];
      const valorDependente = this.state[dependente];

      if (valorCampo !== "" && valorDependente === "") {
        this.borderColor(dependente, "#f70017");
        camposComErro.add(dependente);
      } else if (valorCampo === "" && valorDependente !== "") {
        this.borderColor(campo, "#f70017");
        camposComErro.add(campo);
      } else {
        this.borderColor(campo, "#B5B5B5");
        this.borderColor(dependente, "#B5B5B5");
      }
    }

    if (camposComErro.size > 0) {
      const camposFormatados = Array.from(camposComErro)
        .map(campo => `• ${fieldLabels[campo] || campo.replace(/_/g, " ")}`)
        .join("<br>");

      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        html: `Na seção Mais Filtros, os seguintes campos obrigatórios não foram preenchidos:<br><br>${camposFormatados}`,
        confirmButtonText: "Ok!",
      });
      return;
    }

    this.borderColor(["lab", "cnpj_number"], "#B5B5B5");
    this.borderColor(["data_inicio", "data_fim", "pedido_otica"], "#B5B5B5");

    this.setState({
      loading: true,
      data_tabela: [],
      resposta_tabela: false,
      classOpacity: "Opacity",
    });

    this.context.showLoading("Buscando pedidos...");
    this.integraPedido();
  }

  openSummary(e) {
    this.setState({ [e.target.id]: e.target.value }, () => {
      if (this.state.open) {
        this.setState({ open: "", arrow: "" });
      } else {
        this.setState({ open: "show-summary", arrow: "active-arrow" });
      }
    });
  }

  checkHealth() {
    const requestOptions = {
      method: "GET",
      headers: {
        laboratorio: this.state.laboratorio_cnpj,
      },
    };

    fetch(process.env.REACT_APP_ESSILOR_API + "gestao-produtos-laboratorio/v1/health", requestOptions).then(response => {
      this.setState({ statusProduct: response.status }, () => {
        fetch(process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/health", requestOptions).then(response => {
          this.setState({ statusOrder: response.status }, async () => {
            if (this.state.statusProduct === 200 || this.state.statusOrder === 200) {
              return true;
            } else {
              this.context.hideLoading();
              Swal.fire({
                html: "O serviço está temporariamente indisponível para este laboratório.<br /> O time do Essilor Conecta já está atuando para resolver o problema.",
                width: "auto",
                icon: "warning",
                title: "Aviso",
                confirmButtonColor: "#00518b",
                customClass: {
                  confirmButton: "x-follow-order__filter-btn",
                },
              }).then(result => {
                if (result.value) {
                  this.setState({
                    redirect: false,
                  });
                }
              });

              return false;
            }
          });
        });
      });
    });
  }

  pedidoSemPromocao(pedido) {
    const promocao = pedido.promocao || {};
    return !(promocao.campanha?.nome || promocao.voucher || promocao.idPar || pedido.campanha || pedido.cupom);
  }

  integraPedido() {
    var requestOptions = {};

    if (this.state.campoCnpjLiberado && this.state.cnpj_number) {
      requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          access_token: sessionStorage.getItem("token"),
          laboratorio: this.state.laboratorio_cnpj,
          otica: this.state.cnpj_number ? CnpjUtils.cleanCnpj(this.state.cnpj_number) : "",
        },
      };
    } else {
      requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          access_token: sessionStorage.getItem("token"),
          laboratorio: this.state.laboratorio_cnpj,
        },
      };
    }

    const buscaSemPromocao = this.state.pedido_campanha === CAMPANHA_SEM_PROMOCAO;

    let params = {
      id: this.state.pedido_laboratorio || "",
      idPedidoOtica: this.state.pedido_otica || "",
      dataInicio: this.state.data_inicio || "",
      dataFim: this.state.data_fim || "",
      tipoPedido: this.state.tipo_pedido || "",
      statusAtual: this.state.pedido_status || "",
      origemPedido: this.state.pedido_origem || "",
      numeroNotaFiscal: this.state.pedido_nota_fiscal || "",
      serieNotaFiscal: this.state.serie_nota_fiscal || "",
      campanha: buscaSemPromocao ? "" : this.state.pedido_campanha || "",
      cupom: this.state.pedido_cupom || "",
      idPar: this.state.pedido_id_par || "",
    };

    Object.keys(params).forEach(key => {
      if (!params[key]) delete params[key];
    });

    let tiposCampanhaParaBuscar = [];
    if (this.state.pedido_campanha && !buscaSemPromocao) {
      const { tipoCampanha = [], lista = [] } = this.state.lista_campanhas_tipos?.items || {};
      const campanhaAtual = this.state.pedido_campanha.trim().toUpperCase();
      const relacao = lista.find(item => item.Campanha_c.toUpperCase() === campanhaAtual);
      if (relacao) {
        tiposCampanhaParaBuscar = tipoCampanha
          .filter(tc => relacao.TipoCampanha_c.toUpperCase().includes(tc.label.toUpperCase()))
          .map(tc => tc.value || tc.label);
      }
    }

    const buildUrlParams = (baseParams, tipoCampanha = null) => {
      const finalParams = { ...baseParams };
      if (tipoCampanha) {
        finalParams.tipoCampanha = tipoCampanha;
      }
      return Object.entries(finalParams)
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join("&");
    };

    const urlParams = buildUrlParams(params);

    if (!this.state.laboratorio_nome) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Selecione um laboratório.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("lab");
      return;
    } else if (this.context.userSession.redeOticas && this.state.redeOticaAux && !this.state.cnpj_number) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Selecione uma ótica.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (this.state.input_cnpj && this.state.redeOticaAux && !this.state.cnpj_number && !this.context.userSession.redeOticas) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "O campo CNPJ é obrigatório.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor("cnpj_number");
      return;
    } else if (
      this.state.laboratorio_nome !== "" &&
      this.state.pedido_otica === "" &&
      this.state.pedido_laboratorio === "" &&
      this.state.data_inicio === "" &&
      this.state.data_fim === ""
    ) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Preencha um campo de filtragem.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["cnpj_number", "lab"]);
      return;
    } else if (this.state.pedido_otica !== "" && this.state.pedido_laboratorio !== "") {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Redefina a busca preenchendo o Pedido Laboratório OU Pedido Ótica",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["pedido_laboratorio", "pedido_otica"]);
      return;
    }

    if (this.state.data_inicio === "" || this.state.data_fim === "") {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: " Por favor, informe um período válido para o seu pedido.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else if (this.state.data_inicio > this.state.data_fim) {
      this.setState({
        loading: false,
        classOpacity: "Nopacity",
      });
      this.context.hideLoading();
      Swal.fire({
        text: "Período da busca inválido: Data inicial maior que data final.",
        title: "Aviso",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ok",
      });
      this.borderColor(["data_inicio", "data_fim"]);
      return;
    } else {
      let ini = new Date(this.state.data_inicio);
      let fim = new Date(this.state.data_fim);
      let diff = (fim.getTime() - ini.getTime()) / 1000 / 3600 / 24;
      if (diff > 60) {
        this.setState({
          loading: false,
          classOpacity: "Nopacity",
        });
        this.context.hideLoading();
        Swal.fire({
          text: "O período de busca não pode ser superior a 60 dias.",
          title: "Aviso",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        this.borderColor(["data_inicio", "data_fim"]);
        return;
      }
    }

    const executarBusca = async () => {
      const baseUrl = process.env.REACT_APP_ESSILOR_API + "gestao-pedidos-laboratorio/v1/pedidos?";
      let allResults = [];
      let hasError = false;
      let errorData = null;
      let responseStatus = 200;

      if (this.state.tipoCampanhaFlag && this.state.pedido_campanha && tiposCampanhaParaBuscar.length > 0) {
        const requests = tiposCampanhaParaBuscar.map(tipo => {
          const urlParamsComTipo = buildUrlParams(params, tipo);
          return fetch(baseUrl + urlParamsComTipo, requestOptions)
            .then(response => {
              if (response.status === 206) this.setState({ result100: true });
              if (response.status === 404) responseStatus = 404;
              if (response.status === 504) responseStatus = 504;
              if (response.status >= 400) responseStatus = response.status;
              return response.json();
            })
            .catch(() => []);
        });

        const results = await Promise.all(requests);
        results.forEach(json => {
          if (Array.isArray(json) && json.length > 0 && !json[0].codigo) {
            allResults = allResults.concat(json);
          } else if (json.length > 0 && json[0].codigo) {
            hasError = true;
            errorData = json;
          }
        });
      } else {
        const urlParamsFinal = (this.state.pedido_campanha && tiposCampanhaParaBuscar.length > 0)
          ? buildUrlParams(params, tiposCampanhaParaBuscar[0])
          : urlParams;
        const response = await fetch(baseUrl + urlParamsFinal, requestOptions);
        responseStatus = response.status;

        switch (response.status) {
          case 206:
            this.setState({ result100: true });
            break;
          case 404:
            this.setState({ result404: true });
            break;
          case 504:
            this.setState({ result504: true });
            break;
          default:
        }

        const json = await response.json();
        if (Array.isArray(json) && json.length > 0 && !json[0].codigo) {
          allResults = json;
        } else if ((json.length > 0 && json[0].codigo) || response.status >= 400) {
          hasError = true;
          errorData = json;
        } else if (json.erro) {
          hasError = true;
          errorData = json;
        }
      }

      if (buscaSemPromocao) {
        allResults = allResults.filter(pedido => this.pedidoSemPromocao(pedido));
      }

      if (hasError && errorData) {
        const mensagem = errorData[0] ? errorData[0].mensagem : errorData.mensagem;
        const codAux = errorData[0] ? errorData[0].codigo : errorData.codigo;

        if (this.state.result404 || responseStatus === 404) {
          this.context.hideLoading();
          Swal.fire({
            text: "O CNPJ da ótica não foi encontrado.",
            icon: "warning",
            title: "Aviso",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok!",
          }).then(result => {
            if (result.value) {
              this.setState({ redirect: false });
              this.borderColor("cnpj_number");
            }
          });
        } else if (this.state.result504 || responseStatus === 504 || codAux === "504") {
          if (this.checkHealth()) {
            Swal.fire({
              text: "Esta requisição está demorando mais do que gostaríamos. Tente refinar sua busca, informando o número do pedido ou um intervalo menor de tempo.",
              icon: "warning",
              title: "Aviso",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok!",
            }).then(result => {
              if (result.value) {
                this.setState({ redirect: false });
                this.borderColor(["pedido_laboratorio", "data_inicio", "data_fim"]);
              }
            });
          }
        } else if (codAux === "401") {
          Swal.fire({
            text: "Sessão expirada.",
            icon: "warning",
            title: "Aviso",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok!",
          }).then(result => {
            if (result.value) {
              this.setState({ redirectL: true });
            }
          });
        } else {
          Swal.fire({
            text: "Tivemos uma falha momentânea de comunicação com o laboratório.",
            title: "Aviso",
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Ok",
          });
        }

        this.setState({ loading: false, classOpacity: "Nopacity" });
        this.context.hideLoading();
        return;
      }

      if (allResults.length === 0) {
        this.setState({ loading: false, classOpacity: "Nopacity" });
        this.context.hideLoading();
        Swal.fire({
          text: "Nenhum registro encontrado.",
          title: "Aviso",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Ok",
        });
        return;
      }

      if (this.state.result100) {
        Swal.fire({
          text: "Estes são os 100 primeiros resultados da sua busca. Para um resultado completo, por favor, especifique melhor os filtros.",
          icon: "warning",
          title: "Aviso",
          showCancelButton: false,
          allowOutsideClick: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Ok!",
        }).then(result => {
          if (result.value) {
            this.setState({ result100: false });
            window.scrollTo(0, this.myRef.offsetTop);
          }
        });
      } else {
        window.scrollTo(0, this.myRef.offsetTop);
      }

      const uniqueResults = allResults.filter((item, index, self) =>
        index === self.findIndex(t => t.id === item.id)
      );

      const sort = uniqueResults.sort((a, b) => new Date(b.dataEntrada) - new Date(a.dataEntrada));

      this.setState({
        data_tabela: sort,
        resposta_tabela: true,
        loading: false,
        classOpacity: "Nopacity",
      });

      this.context.hideLoading();
    };

    executarBusca();
  }

  listarRedesOticas = async laboratorio => {
    this.context.showLoading();
    if (this.context.userSession.modulos.includes("Consulta Rede")) {
      const body = {
        usuario: this.context,
        laboratorio: laboratorio,
        consultaRede: this.context.userSession.modulos.includes("Consulta Rede"),
      };

      try {
        const result = await getRedes(body);
        if (result) {
          if (result.status === 200) {
            this.setState({ redes: result.redes, redeOticaAux: true, cnpj_number: this.state.cnpj_number_aux });
            setTimeout(() => this.context.hideLoading(), 1000);
          } else if (result.status === 404) {
            this.setState({
              cnpj_number_aux: this.state.cnpj_number,
              cnpj_number: "",
              dia_inicio: new Date().setDate(new Date().getDate() - 60),
              dia_fim: new Date(),
              data_inicio: Moment(new Date().setDate(new Date().getDate() - 60)).format("YYYY-MM-DD"),
              data_fim: Moment(new Date()).format("YYYY-MM-DD"),
              autoSearch: true,
            });
          }
        }
      } catch (error) {
        console.error("Erro ao usar a função getRedes:", error.message);
        setTimeout(() => this.context.hideLoading(), 1000);
      }
    } else {
      this.setState({ cnpj_number_aux: this.state.cnpj_number, cnpj_number: "" });
      setTimeout(() => this.context.hideLoading(), 1000);
    }
  };

  render() {
    const { redirectL } = this.state;
    if (this.state.redirect) {
      return <Redirect to="/home" />;
    }

    if (redirectL) {
      return <Redirect to="/" />;
    }
    return (
      <main className="main-tracking" id="main-body-tracking">
        <div className={this.state.classOpacity} id="main-tabela">
          <Back items={[{ label: 'Acompanhe seus pedidos enviados' }]} title="Acompanhe seus pedidos enviados" />
          <Container maxWidth="lg" disableGutters>
          <div className="title-container">
            <h1 className="main-title">Acompanhe seus pedidos enviados</h1>
            <span className="title-shape"></span>
          </div>
          <div className="subtitle-container">
            <p className="subtitle">Acompanhe e veja detalhes dos seus pedidos enviados para laboratórios do grupo EssilorLuxottica.</p>
          </div>
          <div className="row">
            <div className="col-xs-12 col-md-7">
              <TrackingLabChoose onChange={this.setLabData} />
            </div>
            <div className="col-xs-12 col-md-5">
              {this.state.input_cnpj && this.state.redeOticaAux && (
                <TrackingInputCNPJ
                  name="cnpj_number"
                  value={this.state.cnpj_number}
                  onChange={this.handleChange}
                  disabled={!this.state.campoCnpjLiberado}
                  redes={this.state.redes}
                />
              )}
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-xs-12 col-md-3">
              <Input
                name="pedido_laboratorio"
                type="text"
                label="Pedido Laboratório"
                width="100%"
                aria="Número da ordem de serviço no laboratório."
                value={this.state.pedido_laboratorio}
                onChange={this.handleChange}
                tooltip="Número da ordem de serviço no laboratório."
              />
            </div>
            <div className="col-xs-12 col-md-1 text-center pt-3 pl-0">
              <span className="tracking-filters-text">ou</span>
            </div>
            <div className="col-xs-12 col-md-3">
              <Input
                type="text"
                label="Pedido Ótica"
                width="100%"
                name="pedido_otica"
                value={this.state.pedido_otica}
                onChange={this.handleChange}
                tooltip="Seu número interno de pedido para facilitar a localização futura."
              />
            </div>
            <div className="col-xs-12 col-md-5">
              <TrackingInputDate
                dia_inicio={this.state.dia_inicio}
                dia_fim={this.state.dia_fim}
                onChange_inicio={this.handleChange_data_inicio}
                onChange_fim={this.handleChange_data_fim}
              />
            </div>
          </div>

          {this.state.novosFiltrosTracking && (
            <BaseColapse colapse={true} link buttonName={"Mais filtros"} linkClass={"maisFiltros"} colBaseColapseButtonDisplayJustifyContent={"flex-start"}>
              <div className="row w-100 mb-3 mt-2">
                <div className="col-12 d-flex justify-content-end">
                  <a id="btn-limpar-filtros" className="maisFiltros" onClick={() => this.cleanFilters()}>
                    Limpar Filtros
                  </a>
                </div>
              </div>

              <div className="row w-100 cadastralFiltroRow1">
                <div className="col-12 col-md-4">
                  <FilterInput
                    label="Cupom"
                    name="pedido_cupom"
                    value={this.state.pedido_cupom || ""}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.pedido_cupom !== novoValor) {
                        this.setState({ pedido_cupom: novoValor }, () => {
                          this.handleChangeFilter("pedido_cupom");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>

                <div className="col-12 col-md-4">
                  <FilterSelect
                    label="Campanha"
                    name="pedido_campanha"
                    value={this.state.pedido_campanha || ""}
                    items={[OPCAO_SEM_PROMOCAO, ...(this.state.pedido_campanha_lista || [])]}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.pedido_campanha !== novoValor) {
                        this.setState({ pedido_campanha: novoValor }, () => {
                          this.handleChangeFilter("pedido_campanha", "select");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>

                <div className="col-12 col-md-4">
                  <FilterSelect
                    label="Par do Cupom"
                    name="pedido_id_par"
                    value={this.state.pedido_id_par || ""}
                    items={[
                      { label: "1", value: "1" },
                      { label: "2", value: "2" },
                    ]}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.pedido_id_par !== novoValor) {
                        this.setState({ pedido_id_par: novoValor }, () => {
                          this.handleChangeFilter("pedido_id_par", "select");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>
              </div>

              <div className="row w-100 cadastralFiltroRow1">
                <div className="col-12 col-md-3">
                  <FilterSelect
                    label="Status"
                    name="pedido_status"
                    value={this.state.pedido_status || ""}
                    items={[
                      { label: "Aberto", value: "ABERTO" },
                      { label: "Faturado", value: "FATURADO" },
                      { label: "Baixado", value: "BAIXADO" },
                      { label: "Cancelado", value: "CANCELADO" },
                    ]}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.pedido_status !== novoValor) {
                        this.setState({ pedido_status: novoValor }, () => {
                          this.handleChangeFilter("pedido_status");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>

                <div className="col-12 col-md-3">
                  <FilterSelect
                    label="Canal de Origem"
                    name="pedido_origem"
                    value={this.state.pedido_origem || ""}
                    items={[
                      { label: "Portal Conecta", value: "PORTAL_CONECTA" },
                      { label: "Shop9", value: "SHOP9" },
                      { label: "Optisoul", value: "OPTISOUL" },
                      { label: "Routing", value: "ROUTING" },
                      { label: "Centro Visão", value: "CENTRO_VISAO" },
                      { label: "Prevent", value: "PREVENT" },
                    ]}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.pedido_origem !== novoValor) {
                        this.setState({ pedido_origem: novoValor }, () => {
                          this.handleChangeFilter("pedido_origem");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>

                <div className="col-12 col-md-3">
                  <FilterInput
                    label="Nota Fiscal"
                    name="pedido_nota_fiscal"
                    value={this.state.pedido_nota_fiscal || ""}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.pedido_nota_fiscal !== novoValor) {
                        this.setState({ pedido_nota_fiscal: novoValor }, () => {
                          this.handleChangeFilter("pedido_nota_fiscal");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>

                <div className="col-12 col-md-3">
                  <FilterInput
                    label="Série"
                    name="serie_nota_fiscal"
                    value={this.state.serie_nota_fiscal || ""}
                    onChange={e => {
                      const novoValor = e.target.value;
                      if (this.state.serie_nota_fiscal !== novoValor) {
                        this.setState({ serie_nota_fiscal: novoValor }, () => {
                          this.handleChangeFilter("serie_nota_fiscal");
                        });
                      }
                    }}
                    flexDirectionDiv="row"
                    alignItemsDiv="center"
                    justifyContentDiv="flex-end"
                    displayDiv="flex"
                    layout="default"
                  />
                </div>
              </div>
            </BaseColapse>
          )}

          <div className="row">
            <TrackingSearchButton onClick={this.changeState} />
          </div>

          <section ref={ref => (this.myRef = ref)} className="mt-4">
            {this.state.resposta_tabela &&
              (this.state.data_tabela.length > 0 ? (
                <TrackingTableHead
                  laboratorio_nome={this.state.laboratorio_nome}
                  laboratorio_cnpj={this.state.laboratorio_cnpj}
                  detailOrder={this.state.detailOrder}
                  otica_cnpj={
                    this.state.cnpj_number ? this.state.cnpj_number.replace(".", "").replace(".", "").replace("-", "").replace("/", "") : this.state.cnpj_number
                  }
                  data_tabela={this.state.data_tabela}
                />
              ) : (
                <div className="noReponse">
                  <p className="tracking-filters-label text-center">Nenhum registro encontrado.</p>
                </div>
              ))}
          </section>
          </Container>
        </div>
        <ResumoLateral
          logoTransparente={"image/modulos/Conecta_Tracking_transparente.png"}
          lab={this.state.lab}
          lab_logo={this.state.lab?.logo}
          lab_phone={this.state.lab?.phone}
          lab_email={this.state.lab?.email}
          lab_site={this.state.lab?.site}
        />
      </main>
    );
  }
}

export default Tracking;
